import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import JobFunctionEditor from "../../editors/personInfo/jobFunction";

const JobFunctions: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.JobFunctionsList}
			endpoint={Endpoint.JobFunctions}
			addScreen={{ screen: JobFunctionEditor, isAllowed: hasPermission(Permission.JobFunctionsAdd) }}
			editScreen={{ screen: JobFunctionEditor, isAllowed: hasPermission(Permission.JobFunctionsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.JobFunctionsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default JobFunctions;
